import { useLingui } from '@lingui/react/macro';
import React from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import NumberField from './shared/number-field';
import { useCommonFabricProp } from './shared/use-common-fabric-prop';
import type { ObjectInspectorProps } from './types';

const ImageInspector: React.FC<ObjectInspectorProps> = ({ objects, editor }) => {
  const { t } = useLingui();
  const MIXED = t`(разное)`;
  const scaleX = useCommonFabricProp<number>(objects, 'scaleX', editor);
  const scaleY = useCommonFabricProp<number>(objects, 'scaleY', editor);
  const opacity = useCommonFabricProp<number>(objects, 'opacity', editor);

  return (
    <>
      <TransformSection objects={objects} editor={editor} />
      <InspectorSection title={t`Внешний вид`}>
        <InspectorRow label={t`Масштаб X`}>
          <NumberField
            value={scaleX.isMixed ? undefined : scaleX.value}
            onChange={scaleX.setValue}
            step={0.05}
            min={0.01}
            placeholder={scaleX.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
        <InspectorRow label={t`Масштаб Y`}>
          <NumberField
            value={scaleY.isMixed ? undefined : scaleY.value}
            onChange={scaleY.setValue}
            step={0.05}
            min={0.01}
            placeholder={scaleY.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
        <InspectorRow label={t`Прозрачность`}>
          <NumberField
            value={opacity.isMixed ? undefined : opacity.value}
            onChange={opacity.setValue}
            step={0.05}
            min={0}
            max={1}
            placeholder={opacity.isMixed ? MIXED : undefined}
          />
        </InspectorRow>
      </InspectorSection>
    </>
  );
};

export default ImageInspector;

registerInspector('image', ImageInspector);
